<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <!-- <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户</label>
            <em class="weui-form-preview__value">{{initData.cu_name}}</em>
          </div>
        </div> -->
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <span class="weui-form-preview__value">{{initData.pd_inoutno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.pi_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">业务类型</label>
            <span class="weui-form-preview__value" v-if="initData.pd_piclass === 'SALEOUT'">销售出货</span>
            <span class="weui-form-preview__value" v-if="initData.pd_piclass === 'SALERETURN'">销售退货</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{initData.sa_custname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value">{{initData.sa_seller}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">序号</label>
            <span class="weui-form-preview__value">{{initData.pd_pdno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{initData.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{initData.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">数量</label>
            <span class="weui-form-preview__value">{{initData.pd_outqty}}{{initData.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{initData.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{initData.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{initData.pi_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">汇率</label>
            <span class="weui-form-preview__value">{{initData.pi_rate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_netprice}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">含税单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_sendprice}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">税率（%）</label>
            <span class="weui-form-preview__value">{{initData.pd_taxrate}}%</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">税额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_ordertotal - initData.pd_nettotal}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不含税金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_nettotal}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">价税合计（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_ordertotal * initData.pi_rate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">成本单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_price}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">成本金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_total}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">费用分摊金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_feetotal}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">调账金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_tzamount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">毛利润（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_profit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">毛利率（%）</label>
            <span class="weui-form-preview__value">{{initData.pd_profitpresent}}%</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{initData.pd_remark}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>